const ServiceZhCN = {
    subTitle: {
        1: "应用服务",
        content1: "我们将深厚的商业洞察力与技术专长相结合，提供定制化的系统集成方案，与您的团队紧密合作，从概念到实施构建可扩展的解决方案。",
        2: "咨询服务",
        content2: "您的成长就是我们的专长。Blueshine 的经验丰富的顾问团队将成为您团队的延伸，优化流程改进、人才发展和系统升级，推动协调一致的组织变革。您的战略目标超越之时，便是我们成功之日。",
        3: "转型服务",
        content3: "我们根据您企业的独特目标定制解决方案，并提供灵活的实施方案。无论是单独部署还是组合实施，我们的方法都能带来持久的转型，助力您的业务持续发展。",
        4: "电子商务",
        content4: "Blueshine 在电子商务战略和 SAP Hybris 实施方面处于领先地位，利用移动技术、云计算、社交媒体、大数据、分析和人工智能来优化客户体验。",
        5: "招聘与培训服务",
        content5: "我们帮助企业识别并招聘顶尖人才，同时通过针对性培训计划提升员工能力。我们的端到端解决方案助力打造高绩效团队，推动各个层级的持续职业发展。",
        6: "基础设施服务",
        content6: "我们构建并维护关键 IT 基础设施（网络、云、数据中心和安全系统），以增强运营韧性和推动数字化增长。我们的托管服务确保系统稳定运行、数据安全，并优化性能，让您的团队能够专注于战略计划，而非技术维护。",
        7: "研发",
        content7: "人工智能的核心在于构建智能模型，为从预测分析到机器人技术的各种应用提供支持，结合数据科学与类人推理能力。",
        img: {
            app: {
                id: "appService",
                1: "应用开发",
                2: "PRINCE（项目管理方法）",
                3: "应用维护",
                4: "SSADM（结构化系统分析与设计方法）",
                5: "安全服务"
            },
            con: {
                id: "consultingService",
                1: "可行性研究",
                2: "IT 规划",
                3: "技术研究",
                4: "ISSS（信息系统安全服务）",
            },
            transf: {
                id: "transformationService",
                1: "容器/微服务",
                2: "AWS（亚马逊云服务）",
                3: "SCRUM（敏捷开发）",
                4: "Azure（微软云）",
                5: "DevOps（开发运维一体化）"
            },
            eCon: {
                id: "eCommerce",
                1: "SAP Hybris（电商平台）",
            },
            recruitTrain: {
                id: "RecruAndTrainService",
                1: "猎头与人才外包服务",
                2: "人才辅导与培训",
            },
            infra: {
                id: "InfraStrService",
                1: "基础设施设计与构建",
                2: "产品代理、分销与维护",
            },
            rd: {
                id: "RD",
                1: "人工智能",
                2: "机器人技术",
            },
        },
    }
}

export default ServiceZhCN;